import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { emptyBG } from '../resources/images';
import {FormattedMessage} from 'react-intl';

class NotFound extends Component {

  render() {
    return (
      <div className="viewCont emptyState">
        <div className="bodyCont">
          <img src={emptyBG} className="dcImg" alt="not found"/>
          <div className="dcCol">
            <Link to='/' className="dcBtn">
              <div className="animated slideInUp"><FormattedMessage
                  defaultMessage="BACK TO TRACKING"
                  id="404.back-to-home"
              /></div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;